export default [
    {
        key: 'HomeConfigModal',
        getComponent: function () { return import('./homeConfigModal'); },
        title: '首页布局配置',
        width: 748,
    },
    {
        key: 'BasicDataPopup',
        getComponent: function () { return import('./basicDataPopup'); },
        title: '',
        width: 600,
    },
    {
        key: 'TenantDataPopup',
        getComponent: function () { return import('./tenantDataPopup'); },
        title: '',
        width: 400,
    },
];
